<template>
  <a-row>
    <a-col :span="6">
      <a-form-item label="选择系统">
        <a-select
          style="width: 200px"
          placeholder="请选择"
          show-search
          :filterOption="filterOption"
          v-model:value="systemId"
          allowClear
        >
          <a-select-option
            :value="item.id"
            :name="item.name"
            v-for="(item, key) in systems"
            :key="key"
          >
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-item>
    </a-col>
    <a-col :span="6">
      <a-form-item label="角色名称">
        <a-input
          style="width: 200px"
          placeholder="请输入"
          v-model:value="name"
          allow-clear
        ></a-input>
      </a-form-item>
    </a-col>
    <a-col span="8" :offset="4" class="tar">
      <a-button type="primary" @click="initData">查询</a-button>
      <AddRole class="ml10" style="margin-top:4px" />
    </a-col>
  </a-row>
</template>
<script>
import { inject, toRefs } from 'vue'
import AddRole from './AddRole'

export default {
  components: { AddRole },
  setup() {
    const state = inject('state')
    const filterOption = (input, option) => {
      return option.name.toLowerCase().indexOf(input.toLowerCase()) >= 0
    }

    return {
      labelCol: { span: 10 },
      wrapperCol: { span: 14 },
      filterOption,
      ...toRefs(state)
    }
  }
}
</script>
